module.exports = __webpack_public_path__ + "static/email.05c7b346.svg";